export const capitalizeString = (str) => {
    return str.substring(0, 1).toUpperCase() + str.slice(1);
};
//# sourceMappingURL=capitalize-string.js.map